import { render, staticRenderFns } from "./post-manage.vue?vue&type=template&id=289983d8&"
import script from "./post-manage.vue?vue&type=script&lang=js&"
export * from "./post-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports